export default __webpack_public_path__ + "static/media/16.23731102.wav";